

















import { computed, defineComponent, PropType, ref, toRef, watch } from "@vue/composition-api";
import { TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import FilterLanguage from "@/components/FilterLanguage";
import FilterLocation from "@/components/FilterLocation";
import FilterTags from "@/components/FilterTags";
import ModalView from "@/components/ModalView";
import TagsController from "@/components/TagsController";

export default defineComponent({
  name: "CreatorsFiltersModal",
  components: {
    FilterTags,
    BaseButton,
    TagsController,
    ModalView,
    FilterLocation,
    FilterLanguage,
  },
  props: {
    value: { type: Boolean, required: true },
    tagIds: { type: Array as PropType<string[]>, required: true },
    languages: { type: Array as PropType<string[]>, default: () => [] },
    locations: { type: Array as PropType<UserLocation[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const selectedTagsIds = ref<string[]>(props.tagIds);
    const selectedLocations = ref<UserLocation[]>(props.locations);
    const selectedLanguages = ref<string[]>(props.languages);
    const showLocalization = computed(() => !config.featureHideLocalization);
    const showTags = computed(() => config.featureTags);

    const save = () => {
      emit("selectTags", selectedTagsIds.value);
      emit("selectLanguages", selectedLanguages.value);
      emit("selectLocations", selectedLocations.value);
    };

    watch(toRef(props, "value"), newVal => {
      if (newVal) {
        selectedTagsIds.value = props.tagIds;
        selectedLocations.value = props.locations;
        selectedLanguages.value = props.languages;
      }
    });

    return {
      showLocalization,
      showTags,
      TagInfoType,
      selectedTagsIds,
      selectedLocations,
      selectedLanguages,
      save,
    };
  },
});
